<template>
    <modal v-if="isModalVisible" @hide-modal="hideModal()" :width="width" :height="height">
        <template v-slot:content>
            <div class="text-wrapper">
                <div class="flex flex-center">
                    <error-state-icon iconType='error'></error-state-icon>
                </div>
                <h3 class="text-center bold" id="modal-title">{{ webstoreContent.webstoreAlerts.hardware_only_modal.title }}</h3>
                <div class="text-center" id="modal-description">
                    <span>
                        {{ webstoreContent.webstoreAlerts.hardware_only_modal.text }}
                    </span>
                </div>
                <v-button
                    position="center"
                    mobile="11"
                    tablet="9"
                    desktop="9"
                    styling="primary rounded mt-1/2"
                    textAlign="center"
                    :disabled="false"
                    @onClickEvent="continueWithOrder()"
                    >
                    <template v-slot:content>
                        <span>
                            {{ webstoreContent.webstoreAlerts.hardware_only_modal.button1 }}
                        </span>
                    </template>
                </v-button>
                <v-button
                    position="center"
                    mobile="11"
                    tablet="9"
                    desktop="9"
                    styling="secondary rounded"
                    textAlign="center"
                    :disabled="false"
                    @onClickEvent=" hideLicenses ? licensePurchaseRequest() : handleCloseModal()"
                    >
                    <template v-slot:content>
                        <span>
                            {{ hideLicenses ? webstoreContent.webstoreAlerts.hardware_only_modal.button2 : 'Add licenses' }}
                        </span>
                    </template>
                </v-button>
            </div>
        </template>
    </modal>
</template>

<script>
    import {mapActions, mapGetters, mapMutations} from 'vuex';
    import Modal from '../../utils/modal';
    import vButton from '../../utils/button';
    import ErrorStateIcon from '../../utils/error-state-icon';

    export default {

        components: {Modal, vButton, ErrorStateIcon},

        props: [],

        data() {
            return {
                isModalVisible: false,
                windowWidth: window.innerWidth,
            }
        },

        computed: {
            ...mapGetters('content', [
                'webstoreContent'
            ]),

            ...mapGetters('checkout', [
                'hideLicenses',
            ]),

            width() {
                return this.windowWidth > 550 ? '550px' : '90%';
            },
            height() {
                return this.windowWidth > 550 ? '450px' : '90%';
            }
        },

        methods: {
            ...mapActions('shoppingCart', [
                'licensePurchaseRequest'
            ]),

            ...mapMutations([
                'setShoppingCartToClosed',
            ]),

            continueWithOrder() {
                this.$router.push({path: '/review-cart'});
            },

            hideModal() {
                this.isModalVisible = !this.isModalVisible;
            },

            onResize() {
                this.windowWidth = window.innerWidth;
            },

            handleCloseModal() {
                this.setShoppingCartToClosed()
                this.hideModal();
            }
        },

        mounted() {
            this.$nextTick(() => {
                window.addEventListener('resize', this.onResize);
            })
        },

        beforeDestroy() {
            window.removeEventListener('resize', this.onResize);
        }

    }
</script>

<style scoped>

    .text-center {
        text-align: center;
    }

    .text-wrapper {
        font-family: 'Roboto' !important;
        max-width: 100%;
        padding-top: 50px;
    }

    #modal-description {
        padding: 0px 2em;
    }

    #modal-title {
        margin: 0.25em 0em;
    }
</style>
